const colors = {
  pureBlack: '#000',
  pureWhite: '#FFF',
  greyAA: '#AAAAAA',
  blue: '#256fff',
  redError: '#D70000',
}

export default colors
